export const INSCRIPCION = [{
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 15,
    },
    section: {
        position:"relative",
        width: "100%",
        height: "90vh",
        border: "1px solid #000"
    },
    row: {
        flexDirection: 'row'
    },
    column: {
        flexDirection: 'column'
    },
    colContent: {
        paddingHorizontal: 10,
        width: "50%"
    },
    colContentFull: {
        paddingHorizontal: 10,
        width: "100%"
    },
    colContent40: {
        paddingHorizontal: 10,
        width: "20%"
    },
    colContent60: {
        paddingHorizontal: 10,
        width: "80%"
    },
    customMl: {
        paddingHorizontal: 10,
    },
    header1Right: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: 'right',
        /* fontFamily: 'Times-Roman' */
    },
    header1Left: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: 'left',
        /* fontFamily: 'Times-Roman' */
    },
    padHeader: {
        paddingLeft: 15,
        paddingRight: 15,
    },
    header3: {
        fontSize: 10,
        marginBottom: 2,
        paddingTop: 4,
        backgroundColor: "#EEE",
    },
    header4: {
        fontSize: 9,
        paddingTop: 4,
        textAlign: 'left',
        backgroundColor: "#FFF",
    },
    col1: {
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        paddingHorizontal: 10,
        width: 200,
    },
    col2: {
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        textAlign: 'center',
        paddingHorizontal: 10,
        width: 75,
    },
    col3: {
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        textAlign: 'center',
        paddingHorizontal: 10,
        width: 125,
    },
    col4: {
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        borderRight: 0.5,
        textAlign: 'center',
        paddingHorizontal: 10,
        width: 50,
    },
    col5: {
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        paddingHorizontal: 10,
        borderRight: 0.5,
        textAlign: 'center',
        width: 550,
    },
    col6: {
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        paddingHorizontal: 10,
        borderRight: 0.5,
        textAlign: 'right',
        width: 500,
    },
    col7: {
        width: 275,
    },
    col8: {
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        textAlign: 'center',
        paddingHorizontal: 10,
        width: 100,
    },
    custonMt10: {
        marginTop: 10,
    },
    custonMt20: {
        marginTop: 20,
    },
    custonMt30: {
        marginTop: 30,
    },
    Negrita: {
        fontSize: 12,
        fontWeight: "bold"
    },
    Italica: {
        fontStyle: "italic"
    },
    logo: {
        height: 50,
        width:"auto",
        marginLeft: 0,
    },
    textPeq: {
        fontSize: 8,
        marginBottom: 5,
        textAlign: 'left',
        /* fontFamily: 'Times-Roman' */
    },
    titulo: {
        backgroundColor: "#CCC"
    }
}];

export const CONSTANCIA = [{
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        
    },
    section: {
        position:"relative",
        width: "100%",
        height: "90vh",
        border: "1px solid #000"
    },
    encabezado: {
        fontSize: 8,
        marginBottom: 5,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman' */
    },
    encabezado2: {
        fontSize: 12,
        marginBottom: 5,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
    },
    encabezado3: {
        fontSize: 6,
        marginBottom: 5,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
    },
    encabezado4: {
        fontSize: 18,
        marginBottom: 5,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
    },
    encabezado5: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
    },
    bordeConstancia: {
        border: 0.8,
        borderRadius: 4,
        marginLeft: 40,
        marginRight: 40,
    },
    parrafo: {
        paddingLeft: 40,
        paddingRight: 40,
        fontSize: 11,
        textAlign: 'justify',
        justifyContent: 'space-around',
        /* fontFamily: 'Times-Roman', */
    },
    parrafo2: {
        paddingLeft: 15,
        paddingRight: 15,
        fontSize: 11,
        /* fontFamily: 'Times-Roman', */
    },

    lineH: {
        lineHeight: 2
    },

    parrafo2: {
        position: 'absolute',
        padding: 10,
        fontSize: 12,
        right: 10,
        textAlign: 'justify',
        /* fontFamily: 'Times-Roman', */
    },
    nombre: {
        fontSize: 16,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
    },
    logo: {
        height: 80,
        width: 80,
        marginLeft: 260,
    },

    firmaL: {
        height: 80,
        width: 180,
        marginLeft: 210,
        marginTop: 120,
    },

    row: {
        flexDirection: 'row'
    },
    customRow: {
        /* paddingLeft: 40, */
    },
    column: {
        flexDirection: 'column'
    },
    Ecol1: {
        fontSize: 12,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        width: 80,
        backgroundColor: "#777",
        color:"#FFF",
        padding: 1,
    },
    Ecol2: {
        fontSize: 12,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        width: 210,
        backgroundColor: "#777",
        color:"#FFF",
        padding: 1,
    },
    Ecol3: {
        fontSize: 12,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
        borderLeft: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        width: 80,
        backgroundColor: "#777",
        color:"#FFF",
        padding: 1,
    },
    Ecol4: {
        fontSize: 12,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
        borderLeft: 0.5,
        borderRight: 0.5,
        borderTop: 0.5,
        borderBottom: 0.5,
        width: 130,
        backgroundColor: "#777",
        color:"#FFF",
        padding: 1,
    },

    col1: {
        fontSize: 8,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
        width: 80,
        borderBottom: 0.5,
    },
    col2: {
        fontSize: 7,
        textAlign: 'left',
        /* fontFamily: 'Times-Roman', */
        width: 210,
        borderBottom: 0.5,
    },
    col3: {
        fontSize: 8,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
        width: 80,
        borderBottom: 0.5,
    },
    col4: {
        fontSize: 8,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman', */
        width: 130,
        borderBottom: 0.5,
    },

    col9: {
        width: 480,
    },
    col10: {
        width: 70,
    },
    col11: {
        width: 540,
    },
    firma: {
        fontSize: 12,
        marginBottom: 5,
        textAlign: 'center',
        /* fontFamily: 'Times-Roman' */
    },
    footer: {
        fontSize: 8,
        top: 680,
        position: 'absolute',
        textAlign: 'center',
        /* fontFamily: 'Times-Roman' */
    },
    footer2: {
        fontSize: 8,
        top: 725,
        position: 'absolute',
        textAlign: 'center',
        /* fontFamily: 'Times-Roman' */
    },
    footer3: {
        fontSize: 7,
        top: 680,
        position: 'absolute',
        textAlign: 'center',
        marginLeft: 30,
    },
    footer4: {
        fontSize: 7,
        top: 740,
        position: 'absolute',
        textAlign: 'center',
        marginLeft: 30,
    },
    linea: {
        width:530,
        borderBottomColor: "#000",
        borderBottom: 0.5,
        marginLeft: 40,
        marginBottom: 10,
    },
    linea2: {
        width:460,
        borderBottomColor: "#000",
        borderBottom: 0.5,
        marginLeft: 5,
        marginBottom: 5,
    },
    linea3: {
        width:540,
        borderBottomColor: "#000",
        borderBottom: 0.5,
        marginLeft: 5,
        marginBottom: 10,
    },
    logoQr: {
        height: 50,
        width:50,
        marginLeft: 0,
    },

}];

export const LISTADOESTUDIANTES = [{
    body: {
        paddingTop: 35,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
    },
    section: {
        position:"relative",
        width: "100%",
        height: "90vh",
        border: "1px solid #000"
    },
    colContent40: {
        paddingHorizontal: 10,
        width: "20%"
    },
    logo: {
        height: 50,
        width:"auto",
        padding:0,
        marginLeft: 30,
        marginTop: -8
    },
    background: {
        backgroundColor: "#EEE",
    },
    heightColes: {
        height: 15,
        paddingVertical: 2,
    },
    col1: {
        fontSize: 8,
        textAlign: 'center',
        width: 40,
        border: 0.8,
    },
    col2: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'center',
        width: 180,
        border: 0.8,
    },
    col3: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'center',
        width: 100,
        border: 0.8,
    },
    col4: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'center',
        width: 135,
        border: 0.8,
    },
    col5: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'center',
        width: 100,
        border: 0.8,
    },
    col6: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'center',
        width: 30,
        border: 0.8,
    },
    col7: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'left',
        width: 79,
        border: 0.8,
        paddingLeft: 5,
        paddingRight: 5,
    },
    col8: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'left',
        width: 223,
        border: 0.8,
        paddingLeft: 5,
        paddingRight: 5,
    },
    col9: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'left',
        width: 223,
        border: 0.8,
        paddingLeft: 5,
        paddingRight: 5,
    },
    col10: {
        marginLeft: -0.8,
        fontSize: 8,
        textAlign: 'center',
        width: 552,
        border: 0.8,
        paddingLeft: 5,
        paddingRight: 5,
    },
}];


// WEBPACK FOOTER //
// ./src/components/Reportes/Styles/Styles.jsx